import React from 'react';
import { AcceptedProps } from '../interface/accepted-props';
import PhoneType from '../type/string/phone';
import PhoneArrayType from '../type/string/phone-array';
import SMSFieldType from '../type/string/sms';

const Phone: React.FC<AcceptedProps> = (props) => {
  if (props.multiline) {
    return <PhoneArrayType {...props} />;
  } else if (props.isSmsField) {
    return <SMSFieldType {...props} />
  } else {
    return <PhoneType {...props} />
  }
}

export default Phone;